// The name tag (HER-10, ARCH §28.9). PURE (ENG-1).
//
// Naming works on any living mob, in any rule state: the name is cosmetic everywhere, and
// under the heredity rule it also exempts the animal from old age (§28.8). The one piece
// of validation the prompt, the solo seam and the server all share lives here, so the
// three cannot disagree about what a name is.
import { decodeEntityName } from '../engine/saves';
import type { Entity } from '../entities/entity';

/** The prompt's title — BINDING copy (§28.9). */
export const NAME_PROMPT_TITLE = 'Name this animal';

/** A text the name tag accepts: 1..24 printable-ASCII-or-space characters, not blank —
 *  the same rule a save's `name` is decoded against, so a name that could be written can
 *  always be read back. Null for anything else (an empty prompt is a cancel). */
export function validName(text: string): string | null {
  return decodeEntityName(text) ?? null;
}

/** Name `e` (§28.9): validate, then take ONE tag through `takeTag` (the host's inventory —
 *  a solo player's held stack, the server's check of the sender), then set the name and
 *  make the animal persistent (MOB-4: a named animal never despawns). A refused name or a
 *  missing tag changes nothing. A removed entity cannot be named. */
export function nameEntity(e: Entity, text: string, takeTag: () => boolean): boolean {
  if (e.removed) return false;
  const name = validName(text);
  if (name === null) return false;
  if (!takeTag()) return false;
  e.name = name;
  e.persistent = true;
  return true;
}
